import { _ } from "../../../core/polyglot/polyglot.js";
import {
	bulletList,
	liftListItem,
	listItem,
	orderedList,
	sinkListItem,
	wrapInList,
} from "prosemirror-schema-list";
import { keymap } from "prosemirror-keymap";
import AbstractAction from "./AbstractAction.js";

/**
 * Action to add support for "bullet lists" and "ordered list".
 */
export default class ListsAction extends AbstractAction {
	getMenuItems({ schema }) {
		return [
			this._makeMenuItem({
				order: 80,
				title: _("Wrap in ordered list"),
				icon: this._makeIcon({ cssClass: "fa fa-list-ol" }),
				run: wrapInList(schema.nodes.ordered_list),
			}),
			this._makeMenuItem({
				order: 90,
				title: _("Wrap in bullet list"),
				icon: this._makeIcon({ cssClass: "fa fa-list-ul" }),
				run: wrapInList(schema.nodes.bullet_list),
			}),
		];
	}

	getPlugins({ schema }) {
		return [
			keymap({
				Tab: sinkListItem(schema.nodes.list_item),
				"Shift-Tab": liftListItem(schema.nodes.list_item),
			}),
		];
	}

	getNodes() {
		return {
			ordered_list: {
				...orderedList,
				...{ content: "list_item+", group: "block" },
			},
			bullet_list: {
				...bulletList,
				...{ content: "list_item+", group: "block" },
			},
			list_item: {
				...listItem,
				...{ content: "paragraph block*" },
			},
		};
	}
}
